import { LoaderFunctionArgs, LoaderFunction } from 'react-router-dom'

import { eventsApi } from '../../../services/events'
import { sponsorshipApi } from '../../../services/sponsorship'
import type { AppStore } from '../../../store'

export const agendaLoader = (store: AppStore) =>
  (async () => {
    const { data } = await store.dispatch(
      eventsApi.endpoints.listEvents.initiate(undefined, { forceRefetch: true })
    )
    if (!data) return { events: [] }

    const events = data.filter(event => !!event.registration_status || !!event.sponsorship_status)

    return { events }
  }) satisfies LoaderFunction

export const agendaDetailsLoader = (store: AppStore) =>
  (async ({ params }: LoaderFunctionArgs) => {
    const { eventId } = params
    const skip = Number.isNaN(Number(eventId))
    if (skip) throw new Error('Event ID is not a number')

    const { data: event } = await store.dispatch(
      eventsApi.endpoints.getEvent.initiate(Number(eventId), { forceRefetch: true })
    )

    if (!event) throw new Error('Event not found')

    const { data: sponsorship } = !!event?.sponsorship_status
      ? await store.dispatch(
          eventsApi.endpoints.mySponsorship.initiate(Number(eventId), { forceRefetch: true })
        )
      : { data: null }

    const { data: sponsorshipTypes } = await store.dispatch(
      sponsorshipApi.endpoints.mySponsorship.initiate(undefined, { forceRefetch: true })
    )

    const { data: participation } = !!event?.registration_status
      ? await store.dispatch(
          eventsApi.endpoints.myParticipation.initiate(Number(eventId), { forceRefetch: true })
        )
      : { data: null }

    const { data: agendaData } = !!event?.registration_status
      ? await store.dispatch(
          eventsApi.endpoints.myAgenda.initiate(Number(eventId), { forceRefetch: true })
        )
      : { data: null }

    const { data: sessionsData } = await store.dispatch(
      eventsApi.endpoints.listSessions.initiate(Number(eventId), { forceRefetch: true })
    )
    const { data: subEventsData } = await store.dispatch(
      eventsApi.endpoints.listSubEvents.initiate({ id: Number(eventId) }, { forceRefetch: true })
    )

    return {
      event,
      sessions: sessionsData ?? [],
      agenda: agendaData ?? {
        sessions: [],
        sub_events: [],
      },
      subEvents: subEventsData ?? [],
      participation,
      sponsorship,
      sponsorshipTypes,
    }
  }) satisfies LoaderFunction
